import i18n from "../service/i18n";

export const audioPlaybackRates = [0.75, 0.9, 1, 1.25, 1.5, 1.75, 2];
export const videoPlaybackRates = [0.5, 0.75, 0.9, 1, 1.25, 1.5, 2];

export const playbackRateAsString = (rate, language) => {
  const r = rate.toString();
  return language === "fin" ? r.replace(".", ",") : r;
};

export const getPlaybackRateOptionLabel = (
  currentRate: number,
  playbackRates: number[],
  language: string
) => {
  if (currentRate === 1) {
    return i18n("normaalinopeus", { language });
  }
  if (!playbackRates.includes(currentRate)) {
    return `${i18n("vapaavalintainen", {
      language
    })} (${playbackRateAsString(currentRate, language)})`;
  }
  return playbackRateAsString(currentRate, language);
};
